<template>
  <div class="today-task-container">
    <a-row>
      <a-col style="cursor:pointer;"  v-for="(item, index) in barList" @click.stop="jump(item.code)" :key="index" :span="6">
        <div class="box">
          <a-progress type="circle" :strokeWidth="10" :format="(percent) => percent + '%'" :strokeColor="colors[index]" :width="80" :percent="computePercent(item.value)" />
          <p class="label-box">{{ item.label }}</p>
          <p :style="{color: colors[index]}">{{ item.value }}个</p>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  props: {
    spiderStatDaily: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      colors: ['#FD7171', '#FD7171', '#FD7171', '#45DE89',  '#45DE89', '#3C93FF', '#3C93FF',  '#B7C4D4']
    }
  },
  computed: {
    total() {
      return this.barList.reduce((t, c) => t + c.value, 0)
    },
    barList() {
      let _barList = [
        {
          label: '异常退出',
          value: this.spiderStatDaily.spiderScheduleErrorNum,
          code: '-3'
        },
        {
          label: '启动失败',
          value: this.spiderStatDaily.spiderScheduleStartFailNum,
          code: '3'
        },
        {
          label: '重复',
          value: this.spiderStatDaily.spiderScheduleRepeatNum,
          code: '6'
        },
        {
          label: '启动',
          value: this.spiderStatDaily.spiderScheduleStartNum,
          code: '0'
        },
        {
          label: '执行中',
          value: this.spiderStatDaily.spiderScheduleDealNum,
          code: '1'
        },
        {
          label: '队列中',
          value: this.spiderStatDaily.spiderScheduleQueueNum,
          code: '4'
        },
        {
          label: '手动退出',
          value: this.spiderStatDaily.spiderScheduleHandKillNum,
          code: undefined
        },
        {
          label: '未知',
          value: this.spiderStatDaily.spiderScheduleUnKnownNum,
          code: '5'
        }
      ]
      return _barList.filter((bar) => bar.value !== undefined)
    }
  },
  methods: {
    computePercent(num) {
      if (this.total === 0) return 0
      let percent = (num / this.total) * 100
      return Number(percent.toString().substr(0, 4))
    },

    jump(code) {
      if (code) {
        this.$router.push({ name: 'dispatch_task_manage', query: { errorCode: code } })
      } else {
        this.$router.push({ name: 'dispatch_task_manage' })
      }
    }
  }
}
</script>


<style lang="less" scoped>
.today-task-container {
  width: 100%;
  height: 365px;
  .box{
    text-align: center;
    height: 180px;
    padding: 20px;
  }
  .box:hover{
    box-shadow: 0px 2px 8px 0px rgba(0, 7, 38, 0.05);
  }
  .label-box{
    padding: 15px 0 5px 0;
    margin-bottom: 5px;
  }
}
</style>
